import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MoneyTransactionsDataHolder } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthStateFacade } from '../../state/auth/auth-state.facade';

export type MoneyTransactionSortDirection = 'asc' | 'desc';

@Injectable({ providedIn: 'root' })
export class MoneyTransactionsInfrastructure {
  private readonly http = inject(HttpClient);
  private readonly authStateFacade = inject(AuthStateFacade);

  public getMoneyAccountTransactions(
    size: number,
    page: number,
    sortDirection: MoneyTransactionSortDirection = 'desc',
  ): Observable<MoneyTransactionsDataHolder> {
    const customerId = this.authStateFacade.customerId;
    return this.http.get<MoneyTransactionsDataHolder>(environment.apihost + environment.moneytxUrl, {
      params: { size: size, customerId, page, sort: `bookingDate,${sortDirection}` },
    });
  }
}
